import React, {useState, useEffect} from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import './salesTable.scss'
import { db } from '../../firebase';
import { getDoc, doc, collection, onSnapshot, query, limit, orderBy } from 'firebase/firestore' 
import { Link } from 'react-router-dom';



const  SalesTable = () => {

  const [ rows, setRows ] = useState([])

  // useEffect(() => {
    
  //   //LISTEN REAL TIME
    
  //       onSnapshot(collection(db, "subscribers"), (snapShot) => {
  //         let list = [];
  //         snapShot.docs.forEach((doc) => {
  //           list.push({ id: doc.id, ...doc.data()})
  //         })
  //         setRows(list)
          
  //       }, 
  //         (error) => {
  //           console.log(error)
  //         }
  //       ); 
     
  // },[])

  const salesQuery = () => {

    const q = query(collection(db, "subscribers"), orderBy('timeStamp', 'desc'), limit(3));
    onSnapshot(q, (querySnapshot) => {
      const sales = [];
      querySnapshot.forEach((doc) => {
          sales.push({ id: doc.id, ...doc.data()})
      });
    
      setRows(sales)
    });
    
    }
    
    useEffect(() => {
      salesQuery()
    }, [])

  const options = {  maximumFractionDigits: 2   }
  
  return (
    <TableContainer component={Paper} className="table">
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow className="tableRow"> 
   
            <TableCell className='tableCell'>Outlet ID</TableCell>
            <TableCell className='tableCell'>Outlet Name</TableCell>
            <TableCell className='tableCell'>Amount</TableCell>
            <TableCell className='tableCell'>Reg Date</TableCell>
            <TableCell className='tableCell'>Telephone</TableCell>
            <TableCell className='tableCell'>Plan</TableCell>
            {/* <TableCell className='tableCell'>Transaction Ref</TableCell> */}
            <TableCell className='tableCell'>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.id}  className="tableRow">

            <TableCell className='tableCell'>{row.subscriberID}</TableCell>
            <TableCell className='tableCell'>{row.outletname} {row.outlet}</TableCell>
            <TableCell className='tableCell'>N{Intl.NumberFormat("en-US",options).format(row.amount)}.00</TableCell>
            <TableCell className='tableCell'>{row.timeStamp.toDate().toLocaleDateString()}</TableCell>
            <TableCell className='tableCell'>{row.telephone}</TableCell>
            <TableCell className='tableCell'>{row.subscriberPlan ? row.subscriberPlan : "Unpaid"}</TableCell>
             {/* <TableCell className='tableCell'>{row.reference}</TableCell> */}
            <TableCell className='tableCell'>
                {
                    <Link to={`/outlets/${row.id}`} style={{textDecoration:"none"}}>
                    <div style={{
                      color: "green",
                      borderRadius: 5,
                      paddingTop:10,
                      paddingBottom:10,
                      cursor: "pointer",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign:"center",
                      backgroundColor: "lightgreen",
                    }}>
                      View
                    </div>
                 </Link>


                }
                
                </TableCell>
               
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default SalesTable